<p-dialog 
  [modal]="true"
  [closable]="true"
  [maximizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '50vw'}"
  [contentStyle]="{'max-height':'570px'}"
  [(visible)]="_exibir">

  <div 
    class="container-panel">
    <p-panel [showHeader]="false" >
      <div [innerHTML]="politica?.texto"></div>
      <p-footer>
          Data de registro: {{ politica?.dataAlteracao | myDate }}, versão: {{ politica?.versao }}
      </p-footer>
    </p-panel>
  </div>

</p-dialog>